module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/065-eritrea-b9078eeacdda2aa3281d118a5bb9e80f.svg";